<template>
  <j-select-grp-component :width="1000" v-bind="configs" v-on="$listeners" />
</template>

<script>
import JSelectGrpComponent from './JSelectGrpComponent';

export default {
  name: 'JSelectGroup',
  components: { JSelectGrpComponent },
  props: ['value'],
  data() {
    return {
      settings: {
        name: '群聊',
        displayKey: 'groupChatName',
        returnKeys: ['groupChatId', 'groupChatId'],
        listUrl:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/groupBarcode/queryGroupChat',
        queryParamCode: 'name',
        queryParamText: '群名称',
        columns: [
          {
            title: '群名称',
            dataIndex: 'groupChatName',
            align: 'center',
            widthRight: '70%'
          },
          { title: '群主', dataIndex: 'owner', align: 'center' },
          { title: '群人数', dataIndex: 'memberNum', align: 'center' },
          { title: '群成立时间', dataIndex: 'createTime', align: 'center' },
          {
            title: '群二维码',
            dataIndex: 'imageName',
            align: 'center'
            // scopedSlots: {
            //   customRender: 'imageName'
            // },
          }
        ]
      }
    };
  },
  computed: {
    configs() {
      return Object.assign({ value: this.value }, this.settings, this.$attrs);
    }
  }
};
</script>

<style lang="less" scoped></style>
